module.exports = __webpack_public_path__ + "img/insurance.284a26be.png";